<template>
  <div>
     <el-row :gutter="10">
       <el-col :span="5">
         <el-card class="box-card">

         <el-input type="textarea" v-model="goodsIdText"
                   :rows="30"
                   placeholder="请输入商品短链接,多个商品请换行"
         ></el-input>
         </el-card>
       </el-col>
       <el-col :span="19">
         <el-button icon="el-icon-search" @click="generateLinks" >解析</el-button>
         <el-divider></el-divider>
         <el-table  :data="generatedLinksInfo" stripe>
           <el-table-column prop="platform" label="平台"></el-table-column>
           <el-table-column prop="goodsId" label="商品ID"></el-table-column>
           <el-table-column prop="shortUrl" label="商品短链接"></el-table-column>
           <el-table-column prop="goodsUrl" label="商品完整链接"></el-table-column>
         </el-table>
       </el-col>
     </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'

function queryStringToJSON(queryString) {
  if (queryString.indexOf("?") > -1) {
    queryString = queryString.split("?")[1];
  }
  var pairs = queryString.split("&");
  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split("=");
    result[pair[0]] = decodeURIComponent(pair[1] || "");
  });
  return result;
}

export default {
  name: "tbshortlink",
  data() {
    return {
      goodsId: '',
      goodsIds: [],
      goodsIdText:'',
      generatedLinksInfo: [],
      douyinCode:'',
      originUrl:''
    };
  },
  methods: {
    copyUrl() {
      this.$clipboard(this.uploadedLink)
    },
    generateLinks(){
      const _self = this;
      if(this.goodsIdText === '') {
        alert('请输入商品短链接.')
        return;
      }

      this.goodsIds = this.goodsIdText.split('\n')
      if(this.goodsIdText.length === 0) {
        alert('请输入商品短链接.')
        return;
      } else {
        _self.processLink();
      }

    },
    processLink() {
      const _self = this;
      if(this.goodsIds.length > 0) {
        const processGoodsId = this.goodsIds.shift();
        axios.get("/api/getRedirectLink?link=" + processGoodsId)
            .then((content) => {

              if(content.data.indexOf("http") > -1 ){
                const qsObj = queryStringToJSON(content.data)
                console.log(qsObj);
                let realUrl = null;
                let platform = null;
                let goodsId = null;
                if(content.data.indexOf("taobao.com") > -1) {
                  if(qsObj.id) {
                    realUrl = "https://item.taobao.com/item.htm?id=" + qsObj.id;
                    platform = '淘宝/天猫/天猫国际'
                    goodsId= qsObj.id
                  } else if(qsObj.shareDetailItemId) {
                    realUrl = "https://item.taobao.com/item.htm?id=" + qsObj.shareDetailItemId;
                    platform = '淘宝/天猫/天猫国际'
                    goodsId= qsObj.shareDetailItemId
                  }

                } else if(content.data.indexOf("goofish") > -1) {
                  realUrl = "https://www.goofish.com/item?id=" + qsObj.itemId;
                  platform = '闲鱼'
                  goodsId = qsObj.itemId
                }
                if(realUrl){
                  const info = {}
                  info.shortUrl = processGoodsId;
                  info.goodsUrl = realUrl;
                  info.goodsId = goodsId
                  info.platform = platform;
                  _self.generatedLinksInfo.push(info);
                  setTimeout(_self.processLink,150)

                }
              }

        });
      } else {
        alert('无待处理的商品链接');
      }
    },
  },
  mounted() {
  },
};
</script>
